import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CommunicationService } from 'src/app/core/services/communication.service';
import { BranchOfficeModel } from 'src/app/core/models/branch-office.model';
import { UserService } from 'src/app/core/services/user.services';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ConfirmarDialogComponent } from 'src/app/shared/components/confirmar-dialog/confirmar-dialog.component';
import { IOptionsNgSelect } from 'src/app/shared/interfaces/ioptionsNgSelect';
import { UserResponsibleForm } from 'src/app/core/models/interfaces/forms/user-responsible.form';
import { UserResponsibleModel } from 'src/app/core/models/user-responsible.model';
import { TranslateService } from '@ngx-translate/core';
import { MyCommerceService } from 'src/app/core/services/my-commerce.service';
import { Location } from '@angular/common';
import {
  allowDropOnlyLetters,
  allowOnlyLetters,
  allowPasteOnlyLetters,
  EMAIL_REGEXP,
  LETTERS_REGEX
} from 'src/app/shared/functions/input-validations.functions';

@Component({
  selector: 'app-create-edit-responsible',
  templateUrl: './create-edit-responsible.component.html',
  styleUrls: ['./create-edit-responsible.component.scss']
})
export class CreateEditResponsibleComponent implements OnInit {
  form: UntypedFormGroup;
  private readonly RESPONSABLES: string = 'responsibles';

  /*   form: FormGroup; */
  currentEdition: UserResponsibleModel;
  userModel: UserResponsibleModel;

  private viewState: ABMState = ABMState.CREATE;
  dataSource = new Array<BranchOfficeModel>();
  branchOffices: IOptionsNgSelect[];
  branchOfficeSelect: number[];
  isEdition: boolean = false;
  isEdit: boolean = false;
  saving: boolean = false;
  editado: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private communicationService: CommunicationService,
    private userService: UserService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private myCommerceService: MyCommerceService,
    private location: Location
  ) {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.pattern(EMAIL_REGEXP)]),
      nombre: new UntypedFormControl('', [Validators.required, Validators.pattern(LETTERS_REGEX)]),
      apellido: new UntypedFormControl('', [Validators.required, Validators.pattern(LETTERS_REGEX)]),
      rol: new UntypedFormControl('', Validators.required),
      sucursal: new UntypedFormControl('')
    });

    this.currentEdition = new UserResponsibleModel();
    this.userModel = new UserResponsibleModel();
  }

  async ngOnInit() {
    this.getDataBranchOffice();
    await this.route.queryParams.subscribe(async (val) => {
      if (val.responsible) {
        let responsible = await this.myCommerceService.getResponsible(val.responsible);
        this.isEdition = true;
        this.userModel.usuarioId = responsible.usuarioId;
        this.userModel.nombre = responsible.nombre;
        this.userModel.apellido = responsible.apellido;
        this.userModel.email = responsible.email;
        this.userModel.estado = responsible.estado;
        this.userModel.idsSucursal = responsible.idsSucursal;
        this.userModel.rol = responsible.rol;

        this.addToForm('email', this.userModel.email);
        this.addToForm('nombre', this.userModel.nombre);
        this.addToForm('apellido', this.userModel.apellido);
        this.addToForm('rol', this.userModel.rol);
        this.form.controls['email'].disable();
        this.currentEdition = this.userModel;
        this.viewState = ABMState.EDITION;
        this.isEdit = true;
      }
    });
    this.form.controls['nombre'].valueChanges.subscribe(() => (this.editado = this.validarSucursal() ? true : false));
    this.form.controls['apellido'].valueChanges.subscribe(() => (this.editado = this.validarSucursal() ? true : false));
    this.form.controls['sucursal'].valueChanges.subscribe(() => (this.editado = this.validarSucursal() ? true : false));

    this.form.get('rol')?.valueChanges.subscribe((rol: string) => {
      if (rol !== 'RESPONSABLE') {
        this.branchOfficeSelect = [];
        this.form.get('sucursal')?.setValue([]);
      }
    });
  }

  controlForm(): boolean {
    const nombre = this.form.get('nombre')?.value && this.form.get('nombre')?.valid;
    const apellido = this.form.get('apellido')?.value && this.form.get('apellido')?.valid;
    const sucursal = this.form.get('sucursal')?.value;
    const rol = this.form.get('rol')?.value;
    const emailControl = this.form.get('email');
    const emailInvalid =
      (emailControl?.getRawValue() && emailControl?.invalid) || emailControl.getRawValue().length === 0;

    const camposBaseIncompletos = !nombre || !apellido || emailInvalid || !rol;
    const requiereSucursal = rol === 'RESPONSABLE' && (!sucursal || sucursal.length === 0);

    return camposBaseIncompletos || requiereSucursal;
  }

  validarSucursal() {
    var sucursalForm = this.branchOfficeSelect;
    if (!sucursalForm || sucursalForm.length == 0) {
      return false;
    } else {
      return true;
    }
  }

  addToForm(input: string, value: string): void {
    this.form.get(input)?.setValue(value);
  }

  goBack(): void {
    this.communicationService.reset();
    this.location.back();
  }

  async onSubmitEventHandler(form: UserResponsibleForm): Promise<void> {
    sessionStorage.removeItem(this.RESPONSABLES);
    try {
      const rol = this.form.get('rol')?.value;

      form.idsSucursal = rol === 'FINANCIERO' ? [] : this.branchOfficeSelect;

      form.idsSucursal = this.branchOfficeSelect;
      if (this.viewState == ABMState.EDITION) {
        form.idResponsable = this.currentEdition.usuarioId;
        const userResponse = await this.userConfirmation();
        this.saving = true;
        if (!userResponse) {
          this.saving = false;
          return;
        }
      }

      this.saving = true;
      if (this.isEdit) {
        let response = await this.userService.editUserResponsible(this.trimForm(form));
        if (response) {
          this.notificationService.showSuccess(this.getSuccessMessage());
          this.goBack();
        } else {
          throw new Error(this.getErrorMessage());
        }
      } else {
        const response = await this.userService.saveUserResponsible(this.trimForm(form), ABMState.CREATE);
        if (response) {
          this.notificationService.showSuccess(this.getSuccessMessage());
          this.goBack();
        } else {
          throw new Error(this.getErrorMessage());
        }
      }

      this.saving = false;
    } catch (error) {
      this.notificationService.showError(error.message);
      this.saving = false;
    }
  }

  private trimForm(form: UserResponsibleForm): UserResponsibleForm {
    let user = form;
    user.email = form.email;
    user.nombre = form.nombre;
    user.apellido = form.apellido;
    user.rol = form.rol;
    return user;
  }

  async userConfirmation(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        id: 1,
        title: this.translate('pages.responsibles.messages.confirm_update_user'),
        info: this.translate('pages.responsibles.messages.update_user')
      };

      const dialogRef = this.dialog.open(ConfirmarDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((response) => {
        resolve(response != '' && response);
      });
    });
  }

  private getErrorMessage(): string {
    let response = '';
    if (this.viewState == ABMState.CREATE) {
      response = this.translate('pages.responsibles.messages.cant_save_user');
    } else {
      response = this.translate('pages.responsibles.messages.cant_update_user');
    }
    return response;
  }

  private getSuccessMessage(): string {
    let response = '';
    if (this.viewState == ABMState.CREATE) {
      response = this.translate('pages.responsibles.messages.user_registered');
    } else {
      response = this.translate('pages.responsibles.messages.user_updated');
    }
    return response;
  }

  async getDataBranchOffice(): Promise<void> {
    try {
      this.branchOffices = new Array<IOptionsNgSelect>();
      const response = await this.userService.getBranchOfficesCollection();
      if (response) {
        this.dataSource = response;
        this.dataSource.forEach((element) => {
          let ioSelect = { value: element.id, display: element.name };
          this.branchOffices.push(ioSelect as IOptionsNgSelect);
        });
        setTimeout(() => {
          this.branchOfficeSelect = this.currentEdition.idsSucursal;
        }, 500);
      } else {
        this.notificationService.showInfo(this.translate('pages.responsibles.message.dont_exist_branches'));
      }
    } catch (error) {
      this.notificationService.showError(error.message);
    }
  }

  translate(key: string, paramKey?: string): string {
    let param;
    if (paramKey) {
      param = { campo: this.translateService.instant(paramKey) };
    }
    return this.translateService.instant(key, param);
  }

  public checkPattern(event: KeyboardEvent) {
    allowOnlyLetters(event);
  }

  public checkPaste(event: ClipboardEvent) {
    allowPasteOnlyLetters(event);
  }

  public checkDrop(event: DragEvent) {
    allowDropOnlyLetters(event);
  }
}

enum ABMState {
  CREATE = 'C',
  EDITION = 'E'
}
